/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import moment from 'moment-timezone';
import { get } from 'lodash';
import { datePickerOutputToUnix } from 'libs/utils/helpers/datepicker';
import { BACKGROUND_TYPES } from 'libs/services/live-display';
import { SESSION_TYPES, PROVIDER_TYPES, CAPTIONS_SERVICES, RESOLUTION_OPTIONS } from 'libs/services/live-stream';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import CopiableInput from 'shared/ui/components/form-components/CopiableInput.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import SecondaryToolbar from 'shared/ui/components/form-components/SecondaryToolbar.vue';
import DatetimePicker from 'shared/ui/components/form-components/pickers/DatetimePicker.vue';
import LiveDisplayForm from 'ui/components/live-session/LiveDisplayForm.vue';
import HybridHelperBlock from 'ui/components/live-session/HybridHelperBlock.vue';

import InteractivityOptions from 'shared/ui/components/live-sessions/settings/InteractivityOptions.vue';
import SessionType from 'shared/ui/components/live-sessions/SessionType.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';

/**
 * This components shows the live stream form.
 *
 * @vue-prop {Object} event event object
 * @vue-prop {Object} [liveStream] the optional live stream object
 *
 * @category ui.components.live-stream
 * @exports LiveStreamForm
 */
const __vue_script__ = {
    name: 'LiveStreamForm',

    components: {
        BaseInput,
        BaseSelect,
        CopiableInput,
        DatetimePicker,
        LoaderButton,
        Toggler,
        RadioButtons,
        InteractivityOptions,
        SecondaryToolbar,
        SessionType,
        LiveDisplayForm,
        TargetingControl,
        HybridHelperBlock
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        liveStreamDoc: {
            type: Object,
            default: () => null
        },
    },

    data() {
        const aiMedia = {
            label: this.$i18n.t('live_sessions.form.captions.label_ai'),
            value: CAPTIONS_SERVICES.AI_MEDIA
        };

        return {
            liveStream: {},
            blockUntilDate: null,
            startTime: null,
            error: null,
            datetimeFormat: this.$const.DEFAULT_DATETIME_FORMAT,
            dateTimeNotBefore: moment.tz(this.event.timezone).format(this.$const.DEFAULT_DATETIME_FORMAT),
            showSessionTypeSelector: false,
            sessionType: null,
            studioProviderType: PROVIDER_TYPES.STUDIO,
            provider: null,
            showInterprefyOptions: false,
            enableModeration: false,
            enablePollsToggle: false,
            enableTargeting: false,
            enableUpvoting: false,
            showPollNotificationOption: false,
            showPrivateQnaOption: false,
            showHiveToggle: false,
            disableHiveToggle: false,

            interprefyEnabled: false,
            interprefyProjectId: '',
            whoIsWatchingEnabled: false,
            liveDisplayEnabled: false,
            showCaptionsSelector: false,
            orgUsesChime: false,
            inPersonLiveCaptionsSupported: false,
            inPersonCaptionsOpts: [],
            virtualCaptionsOpts: [
                aiMedia,
            ],
            liveCaptions: {
                [SESSION_TYPES.IN_PERSON]: {
                    enabled: false,
                    service: CAPTIONS_SERVICES.WORDLY,
                    session_id: null
                },
                [SESSION_TYPES.VIRTUAL]: {
                    enabled: false,
                    service: CAPTIONS_SERVICES.WORDLY,
                    session_id: null
                }
            },

            interactivityOptions: {},
            targetting: null,
            saving: false,
            targeting: null,

            liveDisplay: {},
            hiveConfig: {},
            hiveEnabled: undefined
        };
    },

    computed: {
        /** @returns {boolean} */
        isThirdParty() {
            return this.$services.liveStream.isThirdParty(this.liveStream);
        },

        /** @returns {boolean} */
        isFinished() {
            return this.$services.liveStream.isFinished(this.liveStream);
        },

        /** @returns {boolean} */
        isVirtual() {
            return this.$services.liveStream.isVirtual(this.liveStream);
        },

        /** @returns {boolean} */
        isInPerson() {
            return this.$services.liveStream.isInPerson(this.liveStream);
        },

        /** @returns {boolean} */
        isHybrid() {
            return this.$services.liveStream.isHybrid(this.liveStream);
        },

        providerOptions() {

            const providerOptions = {
                [PROVIDER_TYPES.STUDIO]: this.$i18n.t('live_sessions.form.providers.spotme_studio'),
                [PROVIDER_TYPES.RTMPS]: this.$i18n.t('live_sessions.form.providers.spotme'),
                [PROVIDER_TYPES.THIRD_PARTY]: this.$i18n.t('live_sessions.form.providers.third_party'),
            };

            if (!this.showSessionTypeSelector) {
                providerOptions[PROVIDER_TYPES.STREAMLESS] = this.$i18n.t('live_sessions.form.providers.streamless');
            }

            return {
                ...providerOptions,

                toArray: () => Object.keys(providerOptions)
                    .map(key => ({
                        label: providerOptions[key],
                        value: key
                    }))
            };
        },

        /**
         * @returns {boolean}
         */
        showVideoInteractions() {
            return !this.isInPerson;
        },

        showViewersToggle() {
            return this.showVideoInteractions && !this.event.is_anonymized;
        },

        /**
         * @returns {boolean}
         */
        showLiveCaptions() {
            return !this.isThirdParty && this.showCaptionsSelector;
        },

        showInPersonLiveCaptions() {
            return this.showLiveCaptions && this.inPersonLiveCaptionsSupported && !this.isVirtual;
        },

        showVirtualLiveCaptions() {
            return this.showLiveCaptions && !this.isInPerson;
        },

        /**
         * @returns {boolean}
         */
        showInterprefy() {
            return this.showInterprefyOptions && !this.isThirdParty && this.showVideoInteractions;
        },

        display: {
            get() {
                return { ...this.liveDisplay };
            },
            set({ field, value }) {
                let display = { ...this.liveDisplay };

                display[field] = value;

                this.liveDisplay = display;
            }
        },
    },

    watch: {

        saving() {
            this.$emit('saving', this.saving);
        },

        /**
         * provider updated
         */
        provider() {
            const provider = get(this.provider, 'value');

            this.liveStream.is_third_party = provider === PROVIDER_TYPES.THIRD_PARTY;
            this.liveStream.use_studio = provider === PROVIDER_TYPES.STUDIO;
            this.liveStream.provider = provider;
        }
    },

    async created() {

        this.liveStream = this.liveStreamDoc || {
            title: null,

            // third party specific
            url: null,
            is_third_party: false,

            start_time: null,
            use_studio: true,
            provider: PROVIDER_TYPES.STUDIO
        };

        this.liveDisplay = this.$services.liveDisplay.prepareDefaultLiveDisplay({
            ...this.liveDisplay,
            show_live_stream: !this.isInPerson,
            show_claps: !this.isInPerson,
            name: 'Main Display'
        });

        const currentTs = Math.floor(Date.now() / 1000);
        const metadata = await this.$services.metadata.getMetadata(this.event.id);

        this.startTime = new Date(this.$utils.time.convertTimestampToHumanForm(this.liveStream.start_time || currentTs, this.event.timezone));
        this.provider = this.toProviderOption(this.liveStream.provider);

        try {
            const orgId = this.event.ownerId;
            const orgName = this.$services.org.getNameFromId(orgId);
            const org = await this.$services.org.getOrg(orgName);

            if (org.show_live_captions) {
                this.showCaptionsSelector = true;
            }

            if (get(metadata, 'live_stream.hive_config')) {
                this.showHiveToggle = this.showVideoInteractions && !this.isThirdParty;
                this.disableHiveToggle = !org.hive?.enabled;
            }
        } catch (e) {
            console.error('cannot get org', e);
        }

        if (get(metadata, 'live_stream.session_type')) {
            this.showSessionTypeSelector = true;
        }

        // initialise default interactivity options
        this.updateInteractivityOptions();

        if (get(metadata, 'live_stream.qna_moderation_enabled')) {
            this.enableModeration = true;
            this.interactivityOptions.qnaModerationEnabled = get(this.liveStream, 'qna_moderation_enabled', true);
        }
        if (get(metadata, 'live_stream.interprefy_enabled')) {
            this.showInterprefyOptions = true;
        }

        if (get(metadata, 'live_stream.polls_enabled')) {
            this.enablePollsToggle = true;
            this.interactivityOptions.pollsEnabled = get(this.liveStream, 'polls_enabled', true);
            this.interactivityOptions.pollsColours = get(this.liveStream, 'polls_colours');
        }

        if (!get(metadata, 'live_stream.poll_targeting_enabled')
            && (get(metadata, 'live_stream.targets') || get(metadata, 'live_stream.exceptions'))
        ) {
            this.enableTargeting = true;
            this.targeting = {
                targets: get(this.liveStream, 'targets', []),
                exceptions: get(this.liveStream, 'exceptions', [])
            };
        }

        if (get(metadata, 'live_stream.qna_upvoting_enabled')) {
            this.enableUpvoting = true;
            this.interactivityOptions.qnaUpvotingEnabled = get(this.liveStream, 'qna_upvoting_enabled', true);
        }

        if (get(metadata, 'live_stream.multicast_enabled')) {
            const wordly = {
                label: this.$i18n.t('live_sessions.form.captions.label_wordly'),
                value: CAPTIONS_SERVICES.WORDLY
            };
            this.inPersonCaptionsOpts.unshift(wordly);
            this.virtualCaptionsOpts.unshift(wordly);
        }

        if (get(metadata, 'live_stream.polls_notifications_enabled')) {
            this.showPollNotificationOption = true;
            this.interactivityOptions.pollsNotificationsEnabled = get(this.liveStream, 'polls_notifications_enabled', true);
        }

        if (get(metadata, 'live_stream.qna_private_enabled')) {
            this.showPrivateQnaOption = true;
            this.interactivityOptions.qnaPrivateEnabled = get(this.liveStream, 'qna_private_enabled', false);
        }

        if (get(metadata, 'live_stream.live_captions')) {
            this.inPersonLiveCaptionsSupported = true;
        }
    },

    beforeDestroy() {
        this.liveStream = null;
    },

    methods: {
        /**
         * react to change to interactivity options in child component
         *
         * @param {object} payload
         * @param {string} payload.field object field to change
         * @param {any} payload.value new value to store
         */
        changeInteractivityOptions({ field, value }) {
            this.interactivityOptions = {
                ...this.interactivityOptions,
                [field]: value,
            };
        },

        /**
         * react to changes on session type in child component
         *
         * @param {string} value
         */
        changeSessionType(value) {
            this.sessionType = value;
            this.liveStream = { ...this.liveStream, session_type: value };

            if (value === SESSION_TYPES.IN_PERSON) {
                this.provider = this.toProviderOption(PROVIDER_TYPES.STREAMLESS);
            } else {
                this.provider = this.toProviderOption(PROVIDER_TYPES.STUDIO);
            }
        },

        /**
         * Saves live stream
         */
        async save() {
            const valid = await this.$refs.form.validate();

            if (!valid) { return; }

            this.liveStream = this.prepareLiveStreamForSaving(this.liveStream);

            this.saving = true;
            try {
                if (this.liveStream._id) {
                    await this.$services.liveStream.updateDoc(this.event.id, this.liveStream);
                } else {
                    const isStudio = this.liveStream.provider === PROVIDER_TYPES.STUDIO;
                    if (isStudio) {
                        this.liveStream.config_overwrites = {
                            hls: {
                                maxResolution: RESOLUTION_OPTIONS.x720
                            }
                        };
                    }
                    const newDoc = await this.$services.liveStream.createDoc(this.event.id, this.liveStream);

                    if (this.liveDisplayEnabled) {
                        // if image is selected as background but no image is provided..
                        if (
                            this.display.background_type === BACKGROUND_TYPES.IMAGE &&
                            !this.display?.image?.[0]
                        ) {
                            // ..fall back to color background
                            this.display.background_type = BACKGROUND_TYPES.COLOR;
                        }

                        await this.$services.liveDisplay.createOrUpdateDoc(this.event.id, newDoc.data.id, {
                            ...this.display,
                            image: this.display?.image?.[0] ? [...this.liveDisplay.image] : null,
                            _id: this.display._id,
                        });
                    }

                    this.redirectToLiveStream(newDoc.data.id);
                }

                this.$emit('save');
                this.notify('success', 'save_success');
            } catch (error) {
                const { response } = error;

                if (get(response, 'status') === 400) {
                    const errorMsg = get(response, 'data.error') || this.$i18n.t('live_sessions.messages.save_error');
                    this.$alert.show(null, errorMsg, { buttonClasses: ['primary'] });
                } else {
                    this.notify('error', 'save_error');
                }
            } finally {
                this.saving = false;
            }
        },

        /**
         * Shows notification
         *
         * @param {String} msgType message type (success|error|...)
         * @param {String} msgKey translation key
         */
        notify(msgType, msgKey) {
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t(`live_sessions.messages.${msgKey}`).toString(),
                type: msgType
            });
        },

        /**
         * Redirects to the live stream view
         *
         * @param {String} liveStreamId ID of the live stream to view when redirecting
         */
        redirectToLiveStream(liveStreamId) {
            const isStudio = this.liveStream.provider === PROVIDER_TYPES.STUDIO;
            const newTabUrl = isStudio
                ? this.$services.event.getStudioUrl(this.event, liveStreamId)
                : this.$services.event.getLiveStreamUrl(this.event, liveStreamId);
            this.$router.redirect(newTabUrl, true);
            this.$router.push('/event/:eventId/live_streams');
        },

        /**
         * depending on the stream provider selected, the default interactivity options vary
         *
         * @return {Object} the default interactivity options
         */
        updateInteractivityOptions() {
            const opts = {};
            opts.interprefyEnabled = false;
            opts.interprefyProjectId = null;
            opts.whoIsWatchingEnabled = false;
            opts.clappingEnabled = true;
            opts.qnaEnabled = true;
            opts.pollsEnabled = true;
            opts.qnaModerationEnabled = true;
            opts.qnaAnonymousEnabled = true;
            opts.qnaUpvotingEnabled = true;
            opts.pollsNotificationsEnabled = true;
            opts.qnaPrivateEnabled = false;

            this.interactivityOptions = opts;
        },

        /**
         * maps provider to provider option for the provider select
         *
         * @return {Object}
         */
        toProviderOption(provider) {
            return {
                label: this.providerOptions[provider],
                value: provider
            };
        },

        prepareLiveStreamForSaving(doc) {
            doc.start_time = datePickerOutputToUnix(this.startTime, this.event.timezone);

            if (this.showSessionTypeSelector) {
                doc.session_type = this.sessionType;
            }

            /**
             * VIDEO OPTIONS
             */
            if (!doc.is_third_party) {
                delete doc.url;
            }

            doc.live_captions = this.liveCaptions;
            doc.multicast_enabled = false;

            const virtualCaptionsSettings = this.liveCaptions[SESSION_TYPES.VIRTUAL];

            if (virtualCaptionsSettings.enabled) {
                doc.multicast_enabled = virtualCaptionsSettings.service === CAPTIONS_SERVICES.WORDLY;
            }

            doc.live_captions_labels = {
                caption_1: '',
                caption_2: '',
                caption_3: '',
                caption_4: ''
            };

            doc.who_is_watching = this.whoIsWatchingEnabled;
            doc.interprefy_project_id = this.interprefyProjectId;
            doc.interprefy_enabled = this.interprefyEnabled;
            doc.hive_enabled = this.hiveEnabled;

            /**
             * INTERACTIVITY OPTIONS
             */
            doc.clapping = this.interactivityOptions.clappingEnabled
                && (!this.sessionType || this.sessionType !== SESSION_TYPES.IN_PERSON);

            doc.qna = this.interactivityOptions.qnaEnabled;
            doc.polls_enabled = this.interactivityOptions.pollsEnabled;
            if (doc.polls_enabled) {
                doc.polls_colours = this.interactivityOptions.pollsColours;
            }

            doc.qna_moderation_enabled = this.interactivityOptions.qnaModerationEnabled;
            doc.qna_anonymous_enabled = this.interactivityOptions.qnaAnonymousEnabled;
            doc.qna_upvoting_enabled = this.interactivityOptions.qnaUpvotingEnabled;
            doc.polls_notifications_enabled = this.interactivityOptions.pollsNotificationsEnabled;
            doc.qna_private_enabled = this.interactivityOptions.qnaPrivateEnabled;

            /**
             * DISPLAY OPTIONS
             */
            doc.live_display_enabled = this.liveDisplayEnabled;

            /**
             * TARGET AUDIENCE
             */
            if (this.targeting) {
                doc.targets = this.targeting.targets;
                doc.exceptions = this.targeting.exceptions;
            }

            return doc;
        }
    }
};


/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-stream-form panels panels-c" },
    [
      _c("validation-observer", {
        ref: "form",
        staticClass: "panel",
        attrs: { tag: "form", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.save.apply(null, arguments)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              return [
                _c("validation-provider", {
                  attrs: { name: "title", rules: "required", slim: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("base-input", {
                              attrs: {
                                name: "title",
                                label: _vm.$t("live_sessions.form.title"),
                                type: "text",
                                errors: errors,
                              },
                              model: {
                                value: _vm.liveStream.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.liveStream, "title", $$v)
                                },
                                expression: "liveStream.title",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  attrs: { name: "start_time", rules: "required", slim: true },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("datetime-picker", {
                              attrs: {
                                name: "start_time",
                                label: _vm.$t("live_sessions.form.start_time"),
                                type: "datetime",
                                "show-second": false,
                                "minute-step": 5,
                                errors: errors,
                                format: _vm.datetimeFormat,
                                "not-before": _vm.dateTimeNotBefore,
                                clearable: true,
                              },
                              model: {
                                value: _vm.startTime,
                                callback: function ($$v) {
                                  _vm.startTime = $$v
                                },
                                expression: "startTime",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _vm.showSessionTypeSelector
                  ? _c("session-type", {
                      on: { change: _vm.changeSessionType },
                    })
                  : _vm._e(),
                !_vm.showSessionTypeSelector || _vm.sessionType
                  ? _c(
                      "div",
                      { staticClass: "show-after" },
                      [
                        _vm.isHybrid ? _c("hybrid-helper-block") : _vm._e(),
                        !_vm.isInPerson
                          ? _c(
                              "div",
                              { staticClass: "form-group with-border" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "control-label main-label" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("live_sessions.form.video"))
                                    ),
                                  ]
                                ),
                                _c("validation-provider", {
                                  attrs: { name: "provider", slim: true },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("base-select", {
                                              attrs: {
                                                name: "provider",
                                                label: _vm.$t(
                                                  "live_sessions.form.provider"
                                                ),
                                                validations: "required",
                                                options:
                                                  _vm.providerOptions.toArray(),
                                                "allow-empty": false,
                                                "options-label": "label",
                                                "track-by": "value",
                                                errors: errors,
                                              },
                                              model: {
                                                value: _vm.provider,
                                                callback: function ($$v) {
                                                  _vm.provider = $$v
                                                },
                                                expression: "provider",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm.isThirdParty
                                  ? _c(
                                      "div",
                                      { staticClass: "third-party-inputs" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "url",
                                            slim: true,
                                            rules: "required|url",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("base-input", {
                                                      attrs: {
                                                        name: "url",
                                                        label: _vm.$t(
                                                          "live_sessions.form.url"
                                                        ),
                                                        type: "text",
                                                        errors: errors,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.liveStream.url,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.liveStream,
                                                            "url",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "liveStream.url",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showInterprefy
                                  ? _c(
                                      "validation-provider",
                                      {
                                        attrs: {
                                          name: "interprefy",
                                          slim: true,
                                        },
                                      },
                                      [
                                        _c(
                                          "toggler",
                                          {
                                            attrs: {
                                              name: "interprefy",
                                              "on-label":
                                                "live_sessions.form.interprefy",
                                              "off-label":
                                                "live_sessions.form.interprefy",
                                            },
                                            model: {
                                              value: _vm.interprefyEnabled,
                                              callback: function ($$v) {
                                                _vm.interprefyEnabled = $$v
                                              },
                                              expression: "interprefyEnabled",
                                            },
                                          },
                                          [
                                            _vm.interprefyEnabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "feature-dependant",
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        name: "interprefy_project_id",
                                                        slim: true,
                                                        rules:
                                                          _vm.interprefyEnabled
                                                            ? "required"
                                                            : "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "base-input",
                                                                  {
                                                                    attrs: {
                                                                      name: "interprefy_project_id",
                                                                      label:
                                                                        _vm.$t(
                                                                          "live_sessions.form.interprefy_project_id"
                                                                        ),
                                                                      type: "text",
                                                                      errors:
                                                                        errors,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.interprefyProjectId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.interprefyProjectId =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "interprefyProjectId",
                                                                    },
                                                                  }
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showViewersToggle
                                  ? _c(
                                      "validation-provider",
                                      {
                                        attrs: {
                                          name: "who_is_watching",
                                          slim: true,
                                        },
                                      },
                                      [
                                        _c("toggler", {
                                          attrs: {
                                            name: "who_is_watching",
                                            "on-label":
                                              "live_sessions.form.who_is_watching",
                                            "off-label":
                                              "live_sessions.form.who_is_watching",
                                          },
                                          model: {
                                            value: _vm.whoIsWatchingEnabled,
                                            callback: function ($$v) {
                                              _vm.whoIsWatchingEnabled = $$v
                                            },
                                            expression: "whoIsWatchingEnabled",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showHiveToggle
                                  ? _c(
                                      "validation-provider",
                                      { attrs: { name: "hive", slim: true } },
                                      [
                                        _c("toggler", {
                                          attrs: {
                                            name: "hive",
                                            "on-label":
                                              "live_sessions.form.hive",
                                            "off-label":
                                              "live_sessions.form.hive",
                                            disabled: _vm.disableHiveToggle,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "hint",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "control-hint",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "live_sessions.form.hive_hint"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.disableHiveToggle
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.$utils.links.getLinkUrl(
                                                                "hive_streaming"
                                                              ),
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "live_sessions.form.hive_more_info"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.hiveEnabled,
                                            callback: function ($$v) {
                                              _vm.hiveEnabled = $$v
                                            },
                                            expression: "hiveEnabled",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showInPersonLiveCaptions ||
                        _vm.showVirtualLiveCaptions
                          ? _c(
                              "div",
                              { staticClass: "form-group with-border" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "control-label main-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "live_sessions.form.captions.main_label"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm.showVirtualLiveCaptions
                                  ? _c(
                                      "validation-provider",
                                      {
                                        attrs: {
                                          name: "virtual_live_captions_enabled",
                                          slim: true,
                                        },
                                      },
                                      [
                                        _c(
                                          "toggler",
                                          {
                                            attrs: {
                                              name: "virtual_live_captions_enabled",
                                              "on-label":
                                                "live_sessions.form.captions.virtual_attendees",
                                              "off-label":
                                                "live_sessions.form.captions.virtual_attendees",
                                            },
                                            model: {
                                              value:
                                                _vm.liveCaptions.REMOTE.enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveCaptions.REMOTE,
                                                  "enabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveCaptions.REMOTE.enabled",
                                            },
                                          },
                                          [
                                            _vm.liveCaptions.REMOTE.enabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "captions-options feature-dependant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "control-hint",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "live_sessions.form.captions.virtual_attendees_hint"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("radio-buttons", {
                                                      staticClass:
                                                        "captions-services md-xs",
                                                      attrs: {
                                                        inline: "inline",
                                                        options:
                                                          _vm.virtualCaptionsOpts,
                                                        name:
                                                          "virtual-captions-service-" +
                                                          _vm.liveCaptions
                                                            .REMOTE.service,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.liveCaptions
                                                            .REMOTE.service,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.liveCaptions
                                                              .REMOTE,
                                                            "service",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "liveCaptions.REMOTE.service",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.showInPersonLiveCaptions
                                  ? _c(
                                      "validation-provider",
                                      {
                                        attrs: {
                                          name: "in_person_live_captions_enabled",
                                          slim: true,
                                        },
                                      },
                                      [
                                        _c(
                                          "toggler",
                                          {
                                            attrs: {
                                              name: "in_person_live_captions_enabled",
                                              "on-label":
                                                "live_sessions.form.captions.in_person",
                                              "off-label":
                                                "live_sessions.form.captions.in_person",
                                            },
                                            model: {
                                              value:
                                                _vm.liveCaptions.IN_PERSON
                                                  .enabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.liveCaptions.IN_PERSON,
                                                  "enabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "liveCaptions.IN_PERSON.enabled",
                                            },
                                          },
                                          [
                                            _vm.liveCaptions.IN_PERSON.enabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "captions-options feature-dependant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "control-hint",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "live_sessions.form.captions.in_person_hint"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("radio-buttons", {
                                                      staticClass:
                                                        "captions-services md-xs",
                                                      attrs: {
                                                        inline: "inline",
                                                        options:
                                                          _vm.inPersonCaptionsOpts,
                                                        name:
                                                          "in-person-captions-service-" +
                                                          _vm.liveCaptions
                                                            .IN_PERSON.service,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.liveCaptions
                                                            .IN_PERSON.service,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.liveCaptions
                                                              .IN_PERSON,
                                                            "service",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "liveCaptions.IN_PERSON.service",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "form-group with-border" },
                          [
                            _c(
                              "label",
                              { staticClass: "control-label main-label" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "live_sessions.form.interactivity_main"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "control-hint" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "live_sessions.form.interactivity_hint"
                                  )
                                )
                              ),
                            ]),
                            _c("interactivity-options", {
                              attrs: {
                                "live-stream": _vm.liveStream,
                                "show-polls-option": _vm.enablePollsToggle,
                                "show-qna-moderation-option":
                                  _vm.enableModeration,
                                "show-claps-option": _vm.showVideoInteractions,
                                "show-qna-upvoting-option": _vm.enableUpvoting,
                                "show-poll-notification-option":
                                  _vm.showPollNotificationOption,
                                "show-private-qna-option":
                                  _vm.showPrivateQnaOption,
                              },
                              on: { change: _vm.changeInteractivityOptions },
                              model: {
                                value: _vm.interactivityOptions,
                                callback: function ($$v) {
                                  _vm.interactivityOptions = $$v
                                },
                                expression: "interactivityOptions",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.enableTargeting &&
                        _vm.interactivityOptions.pollsEnabled
                          ? _c(
                              "validation-provider",
                              { attrs: { name: "targeting", slim: true } },
                              [
                                _c("targeting-control", {
                                  attrs: {
                                    name: "targeting",
                                    label: _vm.$t(
                                      "live_sessions.form.targeting"
                                    ),
                                    hint: _vm.$t(
                                      "live_sessions.form.targeting_hint"
                                    ),
                                    "event-id": _vm.event._id,
                                  },
                                  model: {
                                    value: _vm.targeting,
                                    callback: function ($$v) {
                                      _vm.targeting = $$v
                                    },
                                    expression: "targeting",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.isVirtual
                          ? _c(
                              "div",
                              { staticClass: "form-group with-border" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "control-label main-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "live_sessions.form.displays_main"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "control-hint small-hint" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "live_sessions.form.displays_hint"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "validation-provider",
                                  {
                                    attrs: {
                                      name: "live_display_enabled",
                                      slim: true,
                                    },
                                  },
                                  [
                                    _c("toggler", {
                                      attrs: {
                                        name: "live_display_enabled",
                                        "on-label":
                                          "live_sessions.form.live_display_enabled",
                                        "off-label":
                                          "live_sessions.form.live_display_enabled",
                                      },
                                      model: {
                                        value: _vm.liveDisplayEnabled,
                                        callback: function ($$v) {
                                          _vm.liveDisplayEnabled = $$v
                                        },
                                        expression: "liveDisplayEnabled",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.liveDisplayEnabled
                                  ? _c("live-display-form", {
                                      attrs: {
                                        event: _vm.event,
                                        "live-stream": _vm.liveStream,
                                      },
                                      model: {
                                        value: _vm.display,
                                        callback: function ($$v) {
                                          _vm.display = $$v
                                        },
                                        expression: "display",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "secondary-toolbar",
                          [
                            _c(
                              "loader-button",
                              {
                                staticClass: "btn-primary",
                                attrs: { status: _vm.saving, type: "submit" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("live_sessions.actions.save"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/live-stream/LiveStreamForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__